import React from 'react';
interface RequestCertFormProps {
  cert: any;
  handleNext: () => void;
}

const RequestCertForm: React.FC<RequestCertFormProps> = ({
  cert,
  handleNext,
}) => {
  return (
    <div
      className="container-white"
      style={{
        padding: '25px',
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        backgroundColor: '#f9f9f9',
        minWidth: 650,
      }}
    >
      <h3
        style={{
          fontSize: '1.4rem',
          fontWeight: 600,
          color: '#333',
          marginBottom: '15px',
          paddingBottom: '10px',
        }}
      >
        Detalles de la Solicitud de Firma Electrónica
      </h3>

      <div style={{ marginBottom: '15px' }}>
        <p
          style={{
            fontSize: '1rem',
            fontWeight: 500,
            color: '#333',
            margin: '0 0 4px 0',
          }}
        >
          Tipo del Certificado:
        </p>
        <p
          style={{
            fontSize: '1.25rem',
            fontWeight: 'bold',
            color: '#1a1a1a',
            margin: 0,
          }}
        >
          {cert?.name}
        </p>
      </div>

      <div style={{ borderTop: '1px dashed #ccc', paddingTop: '15px' }}>
        <p
          style={{
            fontSize: '1rem',
            fontWeight: 500,
            color: '#333',
            margin: '0 0 4px 0',
          }}
        >
          Descripción:
        </p>
        <p
          style={{
            fontSize: '0.95rem',
            color: '#555',
            lineHeight: 1.5,
            margin: 0,
            marginBottom: 8,
          }}
        >
          {cert?.dsc}
        </p>
      </div>

      <div style={{ borderTop: '1px dashed #ccc', paddingTop: '15px' }}>
        <p
          style={{
            fontSize: '1.1rem',
            fontWeight: 500,
            color: '#333',
            margin: '0 0 10px 0',
          }}
        >
          Documentos Requeridos para la Solicitud:
        </p>
        <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: 0 }}>
          {cert?.documents?.length > 0 ? (
            cert.documents.map((doc: any, index: number) => (
              <li
                key={index}
                style={{
                  fontSize: '0.9rem',
                  color: '#444',
                  marginBottom: '5px',
                }}
              >
                {doc.name}
                {doc.format && (
                  <span style={{ fontStyle: 'italic', color: '#7f8c8d' }}>
                    &nbsp;({doc.format})
                  </span>
                )}
              </li>
            ))
          ) : (
            <li style={{ color: '#c0392b' }}>
              No se especifican documentos requeridos.
            </li>
          )}
        </ul>
      </div>

      <div
        style={{
          marginTop: 'auto',
          width: '100%',
          paddingTop: '20px',
        }}
      >
        <button
          className={`btn btn-report ${'active'} w-100`}
          onClick={() => handleNext()}
          style={{ height: '45px' }}
        >
          <p style={{ margin: 0 }}>Solicitar</p>
        </button>
      </div>
    </div>
  );
};

export default RequestCertForm;
